// AI Generated Test
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { DirectNavigationService } from '@monsido/services/direct-navigation-service/direct-navigation.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';

@Component({
    selector: 'page-details-brokenlinks-table',
    standalone: false,
    template: `
        <table-container
            [noResultMessage]="'Good job! No issues were found' | translate"
            [collection]="items"
            (onPageChange)="pageChange($event)"
            (onPerPageChange)="perPageChange($event)"
            [progress]="progress">
            <table class="table table-hover table-fixed table-vertial-align">
                <thead>
                <tr>
                    <th class="col-1 text-center" [attr.aria-label]="'Check all links in this section' | translate">
                        <table-select-item-all
                                [(selectedItems)]="selected"
                                [items]="items">
                        </table-select-item-all>
                    </th>
                    <th>
                        <page-link-dropdown-all
                                class="inline-block"
                                [(selected)]="selected"
                                [status]="type"
                                (callback)="updatePage()"
                                [pageId]="page?.id">

                        </page-link-dropdown-all>
                        <span translate *ngIf="selected.length === 0">Broken link</span>
                    </th>
                    <th class="col-8 text-right" *ngIf="showAutofix" translate>PageCorrect</th>
                    <th class="col-6 text-right" translate>Response code</th>
                    <th class="col-3 text-right" translate>Type</th>
                    <th *ngIf="!allAreNotIgnored()" class="col-8">&nbsp;</th>
                    <th class="col-10 text-right">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let link of items; trackBy: trackByLinkId">
                    <td class="text-center" [attr.aria-label]="'Check link' | translate">
                        <table-select-item [(selectedItems)]="selected" [item]="link"></table-select-item>
                    </td>
                    <td class="text-ellipsis">
                        <a [href]="link.link.url" target="_blank" aria-describedby="linkOpensInNewTab">{{ link.link.url }}</a>
                    </td>
                    <td class="text-right" *ngIf="showAutofix">
                        <page-fix-icon
                            (cb)="updatePage()"
                            type="link"
                            [subType]="type"
                            [typeId]="link.link.id"
                            [model]="link"
                            *ngIf="link.link.type !== 'form'" />
                    </td>
                    <td class="text-right">
                        <span *ngIf="link.link.status_code >= 0">{{link.link.status_code}}</span>
                        <span
                            *ngIf="link.link.status_code < 0 || link.link.status_code === null"
                            translate
                            ngbTooltip="{{ 'No response received' | translate }}"
                            triggers="focus hover">n/a</span>
                    </td>
                    <td class="text-right">
                        <span class="label label-default">{{link.link.type}}</span>
                    </td>
                    <td class="text-right" *ngIf="type === 'ignored'">
                        <page-link-dropdown
                            [link]="link"
                            (getPage)="updatePage()"
                            [showUnignore]="true"
                            [ignoredValue]="'ignored'"
                            [pageId]="page?.id">
                        </page-link-dropdown>
                    </td>
                    <td class="text-v-middle text-right">
                        <div class="d-flex flex-wrap align-items-center justify-content-end">
                            <button class="btn btn-border-radius btn-secondary mr-1"
                                    triggers="focus hover"
                                    ngbTooltip="{{ 'Open issue page' | translate }}"
                                    (click)="openIssueModal(link)"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'open-issue-view', params: {module: moduleName}}">
                                <span class="fas fa-info-circle" aria-hidden="true"></span>
                            </button>
                            <page-link-dropdown
                                [pageId]="page?.id"
                                [link]="link"
                                (getPage)="updatePage()"
                                [ignoredValue]="'ignored'">
                            </page-link-dropdown>
                            <mon-extension-visual-link-button
                                class="ml-3 my-1"
                                [page]="page"
                                [type]="link.link.type === 'image' ? 'bimg' : 'blnk'"
                                [data]="link">
                            </mon-extension-visual-link-button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </table-container>
    `,
})
export class PageDetailsBrokenlinksTableComponent implements OnInit {
    @Input() selected: any = [];
    @Input() items: any[] = [];
    @Input() type: any;
    @Input() progress: any;
    @Input() page: any;
    @Input() moduleName: any;

    @Output() onPageChange = new EventEmitter<any>();
    @Output() onPerPageChange = new EventEmitter<any>();
    @Output() getPage = new EventEmitter<void>();
    @Output() refreshPage = new EventEmitter<void>();

    showAutofix: boolean = false;

    constructor (
        private activeFeatureService: ActiveFeatureService,
        private monEventService: MonEventService,
        private directNavigationService: DirectNavigationService,
    ) {}

    ngOnInit (): void {
        this.showAutofix = this.activeFeatureService.isFeatureActive('page_fix_qa_links');
        this.monEventService.addListener(MON_EVENTS.RELOAD_QA_BROKEN_PAGE_DETAILS, () => {
            this.updatePage();
        });
    }

    pageChange (page: any): void {
        this.onPageChange.emit(page);
    }

    perPageChange (size: any): void {
        this.onPerPageChange.emit(size);
    }

    updatePage (): void {
        this.refreshPage.emit();
        this.getPage.emit();
    }

    allAreNotIgnored (): boolean {
        return !this.items.find(function (misspelling) {
            return misspelling.type === 'ignored';
        });
    }

    openIssueModal (link: any): void {
        this.directNavigationService.navigateToIssueOverlay({
            issueOverlayIssueId: link.link_id,
            issueOverlayIssueType: link.link.type === 'image' ? 'qaBrokenImage' : 'qaBrokenLink',
            issueOverlayPageId: this.page.id,
            issueOverlayPageLinkId: link.id,
        });
    }

    trackByLinkId (index: number, link: any): any {
        return link.id;
    }
}
